import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgMetal = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 18,
	height: 18,
	viewBox: "0 0 18 18",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M8.29336 0.707011C8.65939 0.341267 9.23858 0.317687 9.63125 0.637675L9.70742 0.707011L17.2934 8.29295L17.3617 8.36814C17.6822 8.76092 17.6595 9.34182 17.2934 9.70799L9.70742 17.2939L9.63125 17.3613C9.26461 17.6605 8.73519 17.6605 8.36855 17.3613L8.29336 17.2939L0.706445 9.70799L0.638086 9.63084C0.339355 9.26421 0.33905 8.73461 0.638086 8.36814L0.706445 8.29295L8.29336 0.707011ZM3.84805 6.56639L8.71621 16.3027L8.99941 16.5859L9.45352 16.1328L4.3959 6.01756L3.84805 6.56639ZM5.14199 5.27244L10.1986 15.3867L12.3744 13.2109L7.31777 3.09666L5.14199 5.27244ZM1.41348 8.99998L4.24258 11.8291L2.35684 8.05662L1.41348 8.99998ZM14.6107 10.9746L16.5863 8.99998L10.6605 3.0742L14.6107 10.9746Z",
		fill: "black"
	})
});
export default SvgMetal;
